import { useEffect, useState } from "react";

/**
 * True when the viewport is at least `px` wide, kept in sync via `matchMedia`.
 * Client-only (our apps have no SSR); the initial value is read synchronously so
 * the first paint is already correct, and falls back to `false` where
 * `matchMedia` is unavailable (e.g. jsdom without a mock).
 */
export function useMinWidth(px: number): boolean {
  const query = `(min-width: ${px}px)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof window.matchMedia !== "function"
    )
      return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);
  return matches;
}
